import {projectCode} from "../resources/constants";

export const setgeneralDetails = (p) => {
    return {
        type: "SET_GENERALDETAILS_DETAILS",
        payload: p,
    };
};


export const setPersonalInfoDetails = (p) => {
    return {
        type: `SET_${projectCode}_PERSONAL_INFO_DETAILS`,
        payload: p,
    };
};

export const setPermissionDetails = (p) => {
    return {
        type: `SET_${projectCode}_PERMISSION_DETAILS`,
        payload: p,
    };
};

export const setFacultyList = (p)=>{
    return{
        type:`SET_${projectCode}_FACULTY_LIST`,
        payload:p
    }
}

export const setDepartmentsList = (p) => {
    return {
        type: `SET_${projectCode}_DEPARTMENT_LIST`,
        payload: p
    }
}

export const setCurrentSemester = (p)=>{
    return{
        type:`SET_${projectCode}_CURRENT_SEMESTER`,
        payload:p
    }
}

export const setGeneral = (p)=>{
    return{
        type:`SET_${projectCode}_GENERAL`,
        payload:p
    }
}

export const setHostelDetails = (p)=>{
    return{
        type:`SET_${projectCode}_HostelDetails`,
        payload:p
    }
}

export const setLoginDetails = (p) => {
    return {
        type: `SET_${projectCode}_LOGIN_DETAILS`,
        payload: p,
    };
};

export const setLogInDetails = (p) => {
    return {
        type: `SET_${projectCode}_PAYMENT_LOGIN_DETAILS`,
        payload: p,
    };
};


export const setWalletData = (p) => {
    return {
        type: `SET_${projectCode}_PAYMENT_WALLET_DATA`,
        payload: p,
    };
};

export const setCourseFeesData = (p) => {
    return {
        type: `SET_${projectCode}_PAYMENT_COURSE_FEES_DATA`,
        payload: p,
    };
};

export const setOtherFeesData = (p) => {
    return {
        type: `SET_${projectCode}_PAYMENT_OTHER_FEES_DATA`,
        payload: p,
    };
};

export const setMinAmountAllowData = (p) => {
    return {
        type: `SET_${projectCode}_PAYMENT_MIN_AMOUNT_ALLOW_DATA`,
        payload: p,
    };
};

export const setScholarshipData = (p) => {
    return {
        type: `SET_${projectCode}_PAYMENT_SCHOLARSHIP_DATA`,
        payload: p,
    };
};

export const setPaymentHistoryData = (p) => {
    return {
        type: `SET_${projectCode}_PAYMENT_HISTORY_DATA`,
        payload: p,
    };
};
